import types from "./types";
import handleAPIErrorResponse from "../../utils/handleAPIResponseError";
import API from "../../axios/physician/PhysicianApi";

// NOTE: ANY CONFIGS THAT COULD BE SENSITIVE ARE EXPOSED TO THE FRONTEND
// ARE WE OK WITH THIS IMPLEMENTATION?

const setConfigsLoading = (status) => ({
    type: types.SET_CONFIGS_LOADING,
    data: status,
});

const setConfig = (payload) => ({
    type: types.SET_CONFIG,
    payload
});

function getConfigs(keys) {
    if (!Array.isArray(keys)) {
        keys = [keys]
    }
    return async (dispatch) => {
        dispatch(setConfigsLoading(true))
        try {
            const configs = await Promise.allSettled(keys.map(key => API.getConfig(key)))
            for (const config of configs) {
                if (config.status === 'fulfilled') {
                    dispatch(setConfig({ key: config.value.data.payload.key, value: config.value.data.payload.value }))
                }
            }
        } catch (e) {
            handleAPIErrorResponse(e, "Error occured while fetching configs")
        } finally {
            dispatch(setConfigsLoading(false))
        }
    }
}

const actions = {
    setConfigsLoading,
    setConfig,
    getConfigs,
};

export default actions;
